<p-panel [header]="'forecastCard.title' | translateWF: 'Forecast'" [toggleable]="true">
  <ng-template pTemplate="icons">
    <p-button
      (onClick)="completeForecast(false)"
      [label]="'forecastCard.save' | translateWF: 'Save and Continue'"
      severity="info"
      [disabled]="dyeingForecastFormGroup.value.created"
    />

    <p-button
      (onClick)="completeForecast(true)"
      [label]="'forecastCard.saveAndComplete' | translateWF: 'Save and Complete'"
      severity="info"
      [disabled]="dyeingForecastFormGroup.value.created"
    />
  </ng-template>

  <p-card>
    <div class="col" [formGroup]="dyeingForecastFormGroup" [ngClass]="dyeingForecastFormGroup.value.created ? 'disabled-panel' : ''">
      <div class="grid-auto-2 items-end">
        <div class="form-box">
          <label for="">
            {{ 'forecastCard.color' | translateWF: 'Color' }}
          </label>
          <p-autocomplete
            fluid
            [suggestions]="colorsSuggestions"
            (completeMethod)="colorTypeAhead($event)"
            [forceSelection]="true"
            field="name"
            formControlName="color"
            [emptyMessage]="'CommonMessages.noResultsFound' | translateWF: 'No Results Found'"
            [dropdown]="true"
            class="w-full"
            [ngClass]="{
              'ng-invalid ng-dirty': dyeingForecastFormGroupSubmitted && dyeingForecastFormGroup.controls['color'].invalid,
            }"
          ></p-autocomplete>
        </div>
        <div class="form-box">
          <label for="">
            {{ 'forecastCard.dyeingMachine' | translateWF: 'Dyeing Machine' }}
          </label>
          <p-autocomplete
            fluid
            [suggestions]="assetsSuggestions"
            (completeMethod)="assetTypeAhead($event)"
            [forceSelection]="true"
            field="assetId"
            formControlName="dyeingAsset"
            [emptyMessage]="'CommonMessages.noResultsFound' | translateWF: 'No Results Found'"
            [dropdown]="true"
            class="w-full"
            [ngClass]="{
              'ng-invalid ng-dirty': dyeingForecastFormGroupSubmitted && dyeingForecastFormGroup.controls['dyeingAsset'].invalid,
            }"
          ></p-autocomplete>
        </div>
        <div class="form-box">
          <label for="">
            {{ 'forecastCard.estimatedStartWeek' | translateWF: 'Estimated Start Week' }}
          </label>
          <p-datepicker fluid [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" class="w-full" />
        </div>
        <div class="form-box">
          <label for="">
            {{ 'forecastCard.estimatedTimeToComplete' | translateWF: 'Estimated Time To Complete' }}
          </label>
          <p-datepicker fluid [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" class="w-full" />
        </div>
      </div>
      <div class="grid-auto-4 items-end">
        <div class="form-box">
          <label for="">
            {{ 'forecastCard.quantityPerPC' | translateWF: 'Quantity Per PC' }}
          </label>
          <p-inputgroup>
            <p-inputnumber
              formControlName="quantityInLbsPerProductionCard"
              [useGrouping]="true"
              mode="decimal"
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              fluid
              class="w-full"
              [ngClass]="{
                'ng-invalid ng-dirty': dyeingForecastFormGroupSubmitted && dyeingForecastFormGroup.controls['quantityInLbsPerProductionCard'].invalid,
              }"
            />
            <p-inputgroup-addon>Lbs</p-inputgroup-addon>
          </p-inputgroup>
        </div>
        <div class="form-box">
          <label for="">
            {{ 'forecastCard.quantityPerPCAfterExtra' | translateWF: 'Quantity Per PC (After Extra)' }}
          </label>
          <p-inputnumber
            formControlName="quantityInLbsPerProductionCardAfterExtra"
            [useGrouping]="true"
            mode="decimal"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            fluid
            class="w-full"
            [ngClass]="{
              'ng-invalid ng-dirty': dyeingForecastFormGroupSubmitted && dyeingForecastFormGroup.controls['quantityInLbsPerProductionCardAfterExtra'].invalid,
            }"
          />
        </div>
        <div class="form-box">
          <label for="">
            {{ 'forecastCard.productionCards' | translateWF: 'Production Cards' }}
          </label>
          <input
            type="text"
            pInputText
            formControlName="productionCardCount"
            class="w-full"
            [ngClass]="{
              'ng-invalid ng-dirty': dyeingForecastFormGroupSubmitted && dyeingForecastFormGroup.controls['productionCardCount'].invalid,
            }"
          />
        </div>
        <div class="form-box">
          <label for="">
            {{ 'forecastCard.totalAfterExtra' | translateWF: 'Total (After Extra)' }}
          </label>
          <p-inputnumber
            [ngModel]="total"
            [ngModelOptions]="{ standalone: true }"
            [useGrouping]="true"
            mode="decimal"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            fluid
            class="w-full"
            [disabled]="true"
          />
        </div>
      </div>

      <!-- quantityInLbsPerProductionCard weight validation message -->
      <div class="p-error mb-[1rem]" *ngIf="dyeingForecastFormGroup.controls['quantityInLbsPerProductionCard'].hasError('maxWeight')">
        {{ 'Quantity_Per_PC_Validator' | translateWF: 'The Quantity Per PC cannot be greater than' }}
        {{ dyeingForecastFormGroup.controls['quantityInLbsPerProductionCard'].getError('maxWeight').max }}
      </div>
      <div class="grid-12 mb-[1rem]">
        @for (fabricExtraForm of dyeingForecastFormGroup.controls.fabricExtraPercentages.controls; track $index) {
          <div class="span-3 mr-2">
            <div class="form-box">
              <label for=""
                >{{ fabricExtraForm.value.fabricCode }} <span class="sm__label">{{ getFabricDescription(fabricExtraForm.value.fabricCode!) }}</span></label
              >
              <p-inputgroup>
                <p-inputgroup-addon> {{ getFabricWeightedPercentage(fabricExtraForm.value.fabricCode) }}% </p-inputgroup-addon>
                <p-inputnumber
                  mode="decimal"
                  [formControl]="fabricExtraForm.controls.percentage"
                  suffix="%"
                  class="w-full"
                  [step]="0.01"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [ngClass]="{
                    'cs-value-positive': fabricExtraForm.value.percentage! > 0,
                    'cs-value-negative': fabricExtraForm.value.percentage! < 0,
                    'ng-invalid ng-dirty': dyeingForecastFormGroupSubmitted && fabricExtraForm.controls['percentage'].invalid,
                  }"
                />
              </p-inputgroup>
            </div>
          </div>
        }
      </div>
    </div>
  </p-card>
</p-panel>
